import React, { useState } from "react"
import MetaTags from "react-meta-tags"

import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  CardTitle,
  CardSubtitle,
  Label,
  Input,
  Container,
  CustomInput,
} from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { Link } from "react-router-dom"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

export default function AddProduct() {
  const [rows1, setrows1] = useState([])
  const [rows2, setrows2] = useState([])

  function handleAddRowNested() {
    const item1 = { name1: "" }
    setrows1([...rows1, item1])
  }

  function handleAddRowNested1() {
    const item2 = { name1: "" }
    setrows2([...rows2, item2])
  }

  //   ----------------------------------------------

  const [ProductSelectedImages, setProductSelectedImages] = useState([])

  const ProductImagesSelectFile = event => {
    const ProductSelectedImages = event.target.files
    const ProductSelectedImagesArray = Array.from(ProductSelectedImages)

    const imagesArray = ProductSelectedImagesArray.map(file => {
      return URL.createObjectURL(file)
    })

    setProductSelectedImages(previousImages =>
      previousImages.concat(imagesArray)
    )

    // FOR BUG IN CHROME
    event.target.value = ""
  }

  function ProductImagesDeleteHandler(image) {
    setProductSelectedImages(ProductSelectedImages.filter(e => e !== image))
    URL.revokeObjectURL(image)
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Add Product | Virtual Supermarket</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumbs title="Dashboard" breadcrumbItem="Add Product" />
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <AvForm className="needs-validation">
                    <Row>
                      <Col md={4}>
                        <Row className="mb-3">
                          <div className="col-lg-12">
                            <label htmlFor="Group">Group *</label>
                            <Input
                              type="select"
                              id="Group"
                              name="Group"
                              className="form-select"
                            >
                              <option value="">
                                ---&nbsp; Please Select Group &nbsp;---
                              </option>
                              <option value="1">Fruits & Vegetables</option>
                              <option value="2">Freshness & Cooling</option>
                              <option value="3">Deep Freezing</option>
                              <option value="4">Sweet & Salty</option>
                            </Input>
                          </div>
                        </Row>
                      </Col>
                      <Col md={4}>
                        <Row className="mb-3">
                          <div className="col-lg-12">
                            <label htmlFor="Category">Product Category *</label>
                            <Input
                              type="select"
                              id="Category"
                              name="Category"
                              className="form-select"
                            >
                              <option value="">
                                ---&nbsp; Please Select Category &nbsp;---
                              </option>
                              <option value="1">Vegetables</option>
                              <option value="2">Dry Fruits</option>
                              <option value="3">
                                Cheese & Cheese Substitute
                              </option>
                              <option value="4">
                                Eggs , Fat & Dairy products
                              </option>
                            </Input>
                          </div>
                        </Row>
                      </Col>
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <Label htmlFor="ProductName">Product Name</Label>
                          <AvField
                            name="ProductName"
                            placeholder="Product Name"
                            type="text"
                            errorMessage="Please Enter Product Name"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="ProductName"
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <Label className="mb-3" htmlFor="ProductType">
                            Product Type*
                          </Label>
                          <br />
                          <Input
                            type="radio"
                            className="form-check-input"
                            id="Veg"
                            name="p_type"
                            checked="checked"
                          />
                          &nbsp;
                          <Label className="form-check-label" htmlFor="Veg">
                            {" "}
                            Veg
                          </Label>
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <Input
                            type="radio"
                            className="form-check-input"
                            id="NonVeg"
                            name="p_type"
                          />
                          &nbsp;
                          <Label className="form-check-label" htmlFor="NonVeg">
                            {" "}
                            Non veg
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <Label className="mb-3" htmlFor="ProductType">
                            Product Type *
                          </Label>
                          <br />
                          <div className="d-flex">
                            <Input
                              type="radio"
                              className="form-check-input"
                              id="ReadyToSell"
                              name="F_type"
                              checked="checked"
                            />
                            &nbsp;
                            <Label
                              className="form-check-label"
                              htmlFor="ReadyToSell"
                            >
                              {" "}
                              Ready to Sell
                            </Label>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <Input
                              type="radio"
                              className="form-check-input"
                              id="Min_Prep_Time"
                              name="F_type"
                            />
                            &nbsp;
                            <AvField
                              name="Min_Prep_Time"
                              placeholder="Min.Prep.Time"
                              type="text"
                              className="form-control"
                              id="Min_Prep_Time"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                      <Col md={4}>
                        <Row className="mb-3">
                          <div className="col-lg-12">
                            <label htmlFor="MaxOrderQuantity">
                              Max Order Quantity *
                            </label>
                            <Input
                              type="text"
                              id="MaxOrderQuantity"
                              name="MaxOrderQuantity"
                              placeholder="Max Order Quantity"
                              className="form-control"
                            ></Input>
                          </div>
                        </Row>
                      </Col>
                      <Col md={4}>
                        <Row className="mb-3">
                          <div className="col-lg-12">
                            <label htmlFor="MinOrderQuantity">
                              Min Order Quantity *
                            </label>
                            <Input
                              type="text"
                              id="MinOrderQuantity"
                              name="MinOrderQuantity"
                              placeholder="Min Order Quantity"
                              className="form-control"
                            ></Input>
                          </div>
                        </Row>
                      </Col>
                      <Col md={4}>
                        <Row className="mb-3">
                          <div className="col-lg-12">
                            <label htmlFor="HSNCode">HSN Code</label>
                            <Input
                              type="text"
                              id="HSNCode"
                              name="HSNCode"
                              placeholder="HSN Code"
                              className="form-control"
                            ></Input>
                          </div>
                        </Row>
                      </Col>
                      <Col md={4}>
                        <Row className="mb-3">
                          <div className="col-lg-12">
                            <label htmlFor="Tax">Tax *</label>
                            <Input
                              type="text"
                              id="Tax"
                              name="Tax"
                              placeholder="Tax"
                              className="form-control"
                            ></Input>
                          </div>
                        </Row>
                      </Col>
                    </Row>
                    <hr />
                    <hr />
                    <Row>
                      <Col md={12} className="repeater">
                        <h5>Packaging Details</h5>
                        <br />
                        <div data-repeater-list="group-a">
                          <div data-repeater-item className="row">
                            <div className="mb-3 col-lg-2">
                              <label className="form-label" htmlFor="Unit">
                                Unit*
                              </label>
                              <input
                                type="text"
                                id="Unit"
                                name="untyped-input"
                                className="form-control"
                              />
                            </div>

                            <div className="mb-3 col-lg-2">
                              <label
                                className="form-label"
                                htmlFor="Packaging Size"
                              >
                                Packaging Size
                              </label>
                              <input
                                type="text"
                                id="Packaging Size"
                                className="form-control"
                              />
                            </div>

                            <div className="mb-3 col-lg-2">
                              <label className="form-label" htmlFor="Price">
                                Price
                              </label>
                              <input
                                type="text"
                                id="Price"
                                className="form-control"
                              />
                            </div>

                            <div className="mb-3 col-lg-2">
                              <label className="form-label" htmlFor="Discount%">
                                Discount%
                              </label>{" "}
                              <input
                                type="text"
                                className="form-control"
                                id="Discount%"
                              />
                            </div>

                            <div className="mb-3 col-lg-2">
                              <label
                                className="form-label"
                                htmlFor="UpdatedPrice"
                              >
                                Updated Price *
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="UpdatedPrice"
                              />
                            </div>

                            <div className="mb-3 col-lg-2">
                              <label className="form-label" htmlFor="AvlQty">
                                Avl Qty *
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="AvlQty"
                              />
                            </div>

                            <Col lg={2} className="align-self-center mb-3">
                              <div className="d-grid">
                                <input
                                  data-repeater-delete
                                  type="button"
                                  className="btn btn-primary"
                                  value="Delete"
                                />
                              </div>
                            </Col>
                          </div>
                        </div>

                        {rows2.map((item2, idx) => (
                          <React.Fragment key={idx}>
                            <div data-repeater-list="group-a" id={"addr" + idx}>
                              <div data-repeater-item className="row">
                                <div className="mb-3 col-lg-2">
                                  <label className="form-label" htmlFor="Unit">
                                    Unit*
                                  </label>
                                  <input
                                    type="text"
                                    id="Unit"
                                    name="untyped-input"
                                    className="form-control"
                                  />
                                </div>

                                <div className="mb-3 col-lg-2">
                                  <label
                                    className="form-label"
                                    htmlFor="Packaging Size"
                                  >
                                    Packaging Size
                                  </label>
                                  <input
                                    type="text"
                                    id="Packaging Size"
                                    className="form-control"
                                  />
                                </div>

                                <div className="mb-3 col-lg-2">
                                  <label className="form-label" htmlFor="Price">
                                    Price
                                  </label>
                                  <input
                                    type="text"
                                    id="Price"
                                    className="form-control"
                                  />
                                </div>

                                <div className="mb-3 col-lg-2">
                                  <label
                                    className="form-label"
                                    htmlFor="Discount%"
                                  >
                                    Discount%
                                  </label>{" "}
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="Discount%"
                                  />
                                </div>

                                <div className="mb-3 col-lg-2">
                                  <label
                                    className="form-label"
                                    htmlFor="UpdatedPrice"
                                  >
                                    Updated Price *
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="UpdatedPrice"
                                  />
                                </div>

                                <div className="mb-3 col-lg-2">
                                  <label
                                    className="form-label"
                                    htmlFor="AvlQty"
                                  >
                                    Avl Qty *
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="AvlQty"
                                  />
                                </div>

                                <Col lg={2} className="align-self-center mb-3">
                                  <div className="d-grid">
                                    <input
                                      data-repeater-delete
                                      type="button"
                                      className="btn btn-primary"
                                      value="Delete"
                                    />
                                  </div>
                                </Col>
                              </div>
                            </div>
                          </React.Fragment>
                        ))}
                        <Button
                          onClick={() => {
                            handleAddRowNested1()
                          }}
                          color="success"
                          className="btn btn-success mt-3 mb-3 mt-lg-0"
                        >
                          <i className="fa fa-plus"></i> &nbsp;Add another Pkg Size
                        </Button>
                      </Col>
                    </Row>
                    <hr />
                    <hr />
                    <Row>
                      {/* <h5>Packaging Details</h5> */}
                      <br />
                      <Col md={12}>
                        <Row className="mb-3">
                          <label htmlFor="UploadProductImages">
                            Upload Product Images *
                          </label>
                          <div className="col-lg-12 row">
                            <div className="col-md-2">
                              <label className="file_block-2">
                                <i
                                  class="fa fa-plus"
                                  style={{
                                    fontSize: "38px",
                                    color: "#000",
                                    // padding: "23px 1px",
                                  }}
                                ></i>
                                <Input
                                  type="file"
                                  name="ProductImages"
                                  onChange={ProductImagesSelectFile}
                                  className="form-control file_none mb-3"
                                  multiple
                                  accept="image/png , image/jpeg, image/webp"
                                />
                              </label>
                            </div>
                            <div className="col-md-10">
                              <div className="business_images">
                                {ProductSelectedImages &&
                                  ProductSelectedImages.map((image, index) => {
                                    return (
                                      <div
                                        key={image}
                                        className="business_image"
                                      >
                                        <img
                                          src={image}
                                          height="100"
                                          width="100"
                                          alt="upload"
                                        />
                                        <Link
                                          onClick={() =>
                                            ProductImagesDeleteHandler(image)
                                          }
                                          style={{
                                            position: "absolute",
                                          }}
                                        >
                                          <i
                                            className="fa fa-window-close"
                                            style={{
                                              fontSize: "20px",
                                            }}
                                          ></i>
                                        </Link>
                                        {/* <p>{index + 1}</p> */}
                                      </div>
                                    )
                                  })}

                                <div className="w-100">
                                  {ProductSelectedImages.length > 0 &&
                                    (ProductSelectedImages.length > 20 ? (
                                      <p className="error">
                                        You can't upload more than 10 images!{" "}
                                        <br />
                                        <span>
                                          please delete{" "}
                                          <b>
                                            {" "}
                                            {ProductSelectedImages.length -
                                              20}{" "}
                                          </b>{" "}
                                          of them{" "}
                                        </span>
                                      </p>
                                    ) : (
                                      <button
                                        className="upload-btn btn btn-primary ml-3 mt-3"
                                        onClick={() => {
                                          console.log(ProductSelectedImages)
                                        }}
                                      >
                                        UPLOAD {ProductSelectedImages.length}{" "}
                                        IMAGE
                                        {ProductSelectedImages.length === 1
                                          ? ""
                                          : "S"}
                                      </button>
                                    ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </Row>
                      </Col>

                      <Col md={6}>
                        <Row className="mb-3">
                          <div className="col-lg-12">
                            <label htmlFor="Description">Description</label>
                            <Input
                              type="textarea"
                              id="Description"
                              name="Description"
                              placeholder="Description"
                              className="form-control"
                            ></Input>
                          </div>
                        </Row>
                      </Col>

                      <Col md={6}>
                        <Row className="mb-3">
                          <div className="col-lg-12">
                            <label htmlFor="Ingredients">Ingredients</label>
                            <Input
                              type="textarea"
                              id="Ingredients"
                              name="Ingredients"
                              placeholder="Ingredients"
                              className="form-control"
                            ></Input>
                          </div>
                        </Row>
                      </Col>

                      <Col md="4">
                        <FormGroup className="mb-3">
                          <Label className="mb-3" htmlFor="ProductAvailability">
                            Product Availability *
                          </Label>
                          <br />
                          <Input
                            type="radio"
                            className="form-check-input"
                            id="Available"
                            name="p_Availability"
                            checked="checked"
                          />
                          &nbsp;
                          <Label
                            className="form-check-label"
                            htmlFor="Available"
                          >
                            {" "}
                            Available
                          </Label>
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <Input
                            type="radio"
                            className="form-check-input"
                            id="NotAvailable"
                            name="p_Availability"
                          />
                          &nbsp;
                          <Label
                            className="form-check-label"
                            htmlFor="NotAvailable"
                          >
                            {" "}
                            Not Available
                          </Label>
                        </FormGroup>
                      </Col>

                      <Col md="4">
                        <FormGroup className="mb-3">
                          <Label className="mb-3" htmlFor="ProductAvailability">
                            Active/Deactive *
                          </Label>
                          <br />
                          <Input
                            type="radio"
                            className="form-check-input"
                            id="Active"
                            name="ActiveDeactive"
                            checked="checked"
                          />
                          &nbsp;
                          <Label className="form-check-label" htmlFor="Active">
                            {" "}
                            Active
                          </Label>
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <Input
                            type="radio"
                            className="form-check-input"
                            id="Deactive"
                            name="ActiveDeactive"
                          />
                          &nbsp;
                          <Label
                            className="form-check-label"
                            htmlFor="Deactive"
                          >
                            {" "}
                            Not Available
                          </Label>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Button color="primary" type="submit">
                      Add Product
                    </Button>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
